import {FormControl} from 'platform/components';
import {UseDocumentPreviewReturnType} from 'platform/document-preview';

import {UseFormReturn} from 'react-hook-form';

import {DeliveryNoteDocumentPreviewFormDefinition} from '../types/DeliveryNoteDocumentPreviewFormDefinition';
import {BasicInformationForm} from './BasicInformationForm';
import {BasicInformationReadOnly} from './BasicInformationReadOnly';

interface BasicInformationCardProps {
  isConfirmed: boolean;
  documentPreview: UseDocumentPreviewReturnType;
  control: FormControl<DeliveryNoteDocumentPreviewFormDefinition>;
  formApi: UseFormReturn<DeliveryNoteDocumentPreviewFormDefinition>;
  onEdit: VoidFunction;
}

export function BasicInformationCard(props: BasicInformationCardProps) {
  return props.isConfirmed ? (
    <BasicInformationReadOnly control={props.control} onEdit={props.onEdit} />
  ) : (
    <BasicInformationForm
      control={props.control}
      formApi={props.formApi}
      documentPreview={props.documentPreview}
    />
  );
}
